const Tag = {
  setArtistasSwiper: function () {      
    const artistasSlider = document.querySelectorAll('[data-swiper-artistas]');

    if (artistasSlider.length > 0) {
      artistasSlider.forEach(artistas => {  
        const artistasSwiper = new Swiper(artistas, {
          watchOverflow: true,
          loop: false,
          slidesPerView: 2,
          spaceBetween: 15,
          speed: 1000,
          autoplay: {
            delay: swiper_delay
          },
          navigation: {
            nextEl: $(artistas).parent().find('.swiper-navigation.-next .icon'),
            prevEl: $(artistas).parent().find('.swiper-navigation.-prev .icon'),
            disabledClass: '-disabled'
          },
          //swiper lazy load
          preloadImages: false,
          watchVisibility: true,
          lazy: {
            loadPrevNext: true,
            Amount: 1,
            loadOnTransitionStart: true
          }
        });

        window.addEventListener('load', () => {
          artistasSwiper.update();

          $height = $(artistas).find('.product-block:first-child .image-src').height();

          $(artistas).parent().find('.swiper-navigation.-prev').css('height', $height);
          $(artistas).parent().find('.swiper-navigation.-next').css('height', $height);
        });
      });
    }
  },
  handleFilters: function () {
    $('.filter-anchor').on('click', function () {
      let $anchor = $(this);
      let $options = $(this).next('.filter-options');

      if ($anchor.hasClass('active')) {
        $anchor.removeClass('active');
        $options.removeClass('active');
      } else {
        $anchor.addClass('active');
        $options.addClass('active');
      }
    });
  },
  init: function () {
    const _this = this;

    _this.handleFilters();
    _this.setArtistasSwiper();
  }
}

window.addEventListener('DOMContentLoaded', () => {
  Tag.init();
});
